import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import compose from 'recompose/compose';
import { withRouter } from 'react-router';
import {
  getMobileScreenSize,
  getTabletSize,
  getShowSummary,
  getMobileHeaderRouteToDashboard
} from '@carvana/purchase-store';
import {
  withDocumentTitle,
  routeTo,
  withExperiment
} from '@carvana/purchase-helpers';
import {
  getDashboardLoading,
  getDashboardSteps,
  getOrderState,
  getDashboardError,
  getOrderId,
  getDashboard,
  getIsLockTimerPaused,
  getPurchaseExperiments,
  getUserId,
  getPurchaseId,
  getStockNumber,
  getNeedsToScheduleTimeSlot,
  getNavigationConfig,
  getVehiclePrice,
  getDashboardOrderSummary
} from 'Components/dashboard/ducks/selectors';
import * as DashboardActions from 'Components/dashboard/ducks/actions';
import {
  getCurrentVehicleId,
  getCurrentVehicleLock,
  getCurrentVehicleIds,
  getCurrentVehicleLockTime,
  getIsWIPVehicle,
  getIsReservedVehicle,
  getIsPurchasable,
  getIsMarketplaceVehicle
} from 'Components/vehicle/ducks/selectors';
import { getPhoneNumber } from 'Components/app/ducks/selectors';
import Dashboard from './dashboard';

const mapStateToProps = state => ({
  isMobile: getMobileScreenSize(state),
  isTablet: getTabletSize(state),
  isLoading: getDashboardLoading(state),
  steps: getDashboardSteps(state),
  showSummary: getShowSummary(state),
  vehicleId: getCurrentVehicleId(state),
  vehicleLock: getCurrentVehicleLock(state),
  orderSummary: getDashboardOrderSummary(state),
  ...getCurrentVehicleIds(state),
  orderState: getOrderState(state),
  mobileRouteToDashboard: getMobileHeaderRouteToDashboard(state),
  lockTime: getCurrentVehicleLockTime(state),
  isError: getDashboardError(state),
  phoneNumber: getPhoneNumber(state),
  orderId: getOrderId(state),
  dashboard: getDashboard(state),
  isLockedTimerPaused: getIsLockTimerPaused(state),
  dashboardExperiments: getPurchaseExperiments(state),
  userId: getUserId(state),
  purchaseId: getPurchaseId(state),
  stockNumber: getStockNumber(state),
  navigationConfiguration: getNavigationConfig(state),
  needsToScheduleTimeSlot: getNeedsToScheduleTimeSlot(state),
  isWIPVehicle: getIsWIPVehicle(state),
  isReservedVehicle: getIsReservedVehicle(state),
  isPurchasable: getIsPurchasable(state),
  isMarketplaceVehicle: getIsMarketplaceVehicle(state),
  vehiclePrice: getVehiclePrice(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...DashboardActions, routeTo }, dispatch);

export default compose(
  withRouter,
  withDocumentTitle('Dashboard'),
  withExperiment,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Dashboard);
